import { Box } from "@mui/material";
import DataListingComponent from "../../Component/DataListingComponent";
import { useEffect, useState } from "react";
import { API_endspoints } from "../../API/API_endspoints";
import { API_GET, API_GET2 } from "../../API/config";
import { useLocation } from "react-router-dom";
import moment from "moment";

const PAGE_SIZE_OPTIONS = [15];
const MyPaymentTab = () => {
  const location = useLocation();
  // const [userDetails, setUserDetails] = useState({});
  const [bookingData, setBookingData] = useState([]);
  // const [index, setIndex] = useState(0);
  const [IsLoading, setIsLoading] = useState(true);
  const [totalData, setTotalData] = useState(0);
  const [page, setPage] = useState(0);
  // const [OpenDetailsModal, setOpenDetailsModal] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);
  let U_id = location.state;

  const getBookingData = async (page = 0, pageSize = PAGE_SIZE_OPTIONS[0]) => {
    try
    {
      setIsLoading(true);
      let count = page * pageSize;
      let res = await API_GET(
        `${API_endspoints.GetPaymentHistory}?count=${count}&offset=${pageSize}&user_id=${U_id}`
      );
      if (res?.s)
      {
        const Rowdata = res?.r?.map((data, i) => ({
          rowid: i + 1,
          ...data,
        }));
        setBookingData(Rowdata);
        setTotalData(res?.c || 0);
      } else
      {
        setBookingData([]);
        setTotalData(0);
      }
      setIsLoading(false);
    } catch (error)
    {
      setIsLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getBookingData(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const column = [
    {
      headerClassName: "super-app-theme--header",
      field: "rowid",
      headerName: "#",
      width: 50,
      headerAlign: "center",
    },

    {
      headerClassName: "super-app-theme--header",
      field: "plan_id",
      headerName: "Plan ID",
      flex: 1,
      minWidth: 270,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "subscription_id",
      headerName: "Subscription / Payment ID",
      flex: 1,
      minWidth: 270,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "created_at",
      headerName: "Subscribe Date",
      flex: 1,
      minWidth: 270,
      headerAlign: "center",
      renderCell: (cell) => (
        <span>{`${moment
          .utc(cell?.row?.created_at)
          .local()
          .format("LLL")}`}</span>
      ),
    },
    {
      headerClassName: "super-app-theme--header",
      field: "type",
      headerName: "Type",
      width: 100,
      headerAlign: "center",
      renderCell: (cell) =>
        cell?.row?.type === 0
          ? "Trial"
          : cell?.row?.type === 1
            ? "Subscription"
            : cell?.row?.type === 2 && "One Time",
    },

    {
      headerClassName: "super-app-theme--header",
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 130,
      headerAlign: "center",
      renderCell: (cell) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span
            style={{
              color:
                cell.value === "ACTIVE"
                  ? "green"
                  : cell.value === "APPROVAL_PENDING"
                    ? "grey"
                    : "red",
              fontWeight: 600,
            }}
          >
            {cell.value === "APPROVAL_PENDING"
              ? "Approval Pending"
              : cell.value === "ACTIVE"
                ? "Active"
                : cell?.value?.charAt(0)?.toUpperCase() +
                cell?.value?.slice(1).toLowerCase()}
          </span>
        </Box>
      ),
    },
  ];

  const handlePageChange = (e, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };
  return (
    // <Box sx={{ width: "calc(100% - 240px)" }}>

    <Box sx={{ height: "calc(100% - 40px)" }}>
      <DataListingComponent
        data={bookingData ?? []}
        PAGE_SIZE_OPTIONS={PAGE_SIZE_OPTIONS}
        loading={IsLoading}
        totalData={totalData}
        page={page}
        Footer={true}
        columns={column}
        rowsPerPage={rowsPerPage}
        handlePageChange={handlePageChange}
        handleRowsPerPageChange={handleRowsPerPageChange}
      />
      {/* </Box> */}
    </Box>
  );
};

export default MyPaymentTab;
